export default "__VITE_ASSET__ee756401__"